import React from "react";
import TextArea from "components/atoms/textArea/index.jsx";
import Label from "components/atoms/label/index.jsx";

import "./styles.scss";

export default class FormTextArea extends React.Component {
  render() {
    let { input, label, meta, ...etc } = this.props;

    meta = meta || {};

    return (
      <div className="formTextArea">
        <Label label={label} />
        <TextArea input={input} placeholder="" size="big" {...etc} />
        {meta.touched && meta.error && (
          <span className="error">{meta.error}</span>
        )}
      </div>
    );
  }
}
